import { useQuery } from '@tanstack/react-query'
import { clientApi } from '@/lib/api-client'
import { DEFAULT_ACCOUNT_OPTIONS } from '@/lib/account-options'

export function useAccountOptions() {
  return useQuery({
    queryKey: ['client', 'account-options'],
    queryFn: () => clientApi.getAccountOptions(),
    placeholderData: DEFAULT_ACCOUNT_OPTIONS,
  })
}
